import { useMutation, useQueryClient } from '@tanstack/react-query';
import { memberSignup } from 'api';
import { toastEmitter } from 'components/Toast';

export default function useMemberSignup({
  handleSuccess = () => null,
  handleError = () => null,
} = {}) {
  const queryclient = useQueryClient();

  const Request = useMutation({
    mutationFn: memberSignup,
    mutationKey: ['memberSignup'],
    onSuccess: (data) => {
      const status = data?.status;
      const responseData = data?.data;
      if (status !== 200) {
        handleError();
        return toastEmitter('error', responseData?.error?.message);
      }
      handleSuccess();
      queryclient.invalidateQueries(['getMemberListing']);
      toastEmitter('success', responseData?.data?.message);
    },
  });
  return { ...Request };
}
